"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ClinicianPaidToBy = _interopRequireDefault(require("./ClinicianPaidToBy"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _ClinicianPaidToBy.default;
exports.default = _default;